import { useQuery } from "@tanstack/react-query";
import { authClient } from "./api";

/**
 * "Who is signed in", for the admin dashboard's gate: the shared client's
 * `/api/auth/session`, which also renews an expired session on the way.
 */
export function useSession() {
  return useQuery({
    queryKey: ["session"],
    queryFn: ({ signal }) => authClient.fetchSession(signal),
  });
}
